export default function trackSigninClickFromExistingUserMessage() {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'SurveySignupExistingUserSigninClick',
  });
}
